export const API_BASE_URL = import.meta.env.VITE_API_URL;
export const API_BASE_PREFIX = import.meta.env.VITE_API_PREFIX;
export const APP_RECAPTCHA_SITE_KEY = import.meta.env
  .VITE_APP_RECAPTCHA_SITE_KEY;
export const APP_GTAG_CONVERSION_ID = import.meta.env
  .VITE__APP_GTAG_CONVERSION_ID;
export const APP_DOMAIN = import.meta.env.VITE_APP_DOMAIN